import { Component, OnInit } from '@angular/core';
import {OauthService} from "./oauth.service";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";


export class AcsComponent implements OnInit {

  acsUrl : SafeResourceUrl = null;

  constructor(private oauth : OauthService, private sanitizer : DomSanitizer) {
    let str : string = `${this.oauth.getServerUrl()}?client_id=${this.oauth.clientId}&scope=${this.oauth.scopes.join(" ")}&redirect_uri=${this.oauth.redirect_uri}`;
    this.acsUrl = this.sanitizer.bypassSecurityTrustResourceUrl(str);

  }

  ngOnInit() {
  }


static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'app-acs',
  template: `<iframe id="acs-api"
                     [src]="acsUrl"
                     style="display: none;">
  </iframe>`,
  styles: [],
  inputs:["login"]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: OauthService, },
{type: DomSanitizer, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}



// WEBPACK FOOTER //
// ../../src/lib/acs.component.ts